import {
  Feature,
  FeatureToggleConfig,
  isFeatureEnabled as isFeatureEnabledBase,
} from '@shopee-user/feature-toggle';
import { config } from '@shopee-user/platform';

const { ENV, LOCALE } = config;

export function createFeatureToggleUtil({
  featureToggleConfig,
}: {
  featureToggleConfig: FeatureToggleConfig;
}): {
  isFeatureEnabled: (
    feature: Feature,
    defaultValue?: boolean,
    deviceFingerprint?: number
  ) => boolean;
} {
  return {
    isFeatureEnabled: (
      feature: Feature,
      defaultValue = false,
      deviceFingerprint
    ) =>
      isFeatureEnabledBase(feature, featureToggleConfig, {
        defaultValue,
        deviceFingerprint,
        ENV,
        LOCALE,
      }),
  };
}
